import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DiscountService from '../../api/services/DiscountService';
import MainPagetitle from '../../layouts/MainPagetitle';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

const EditDiscount = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [discountType, setDiscountType] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      var id = params.id;
      getDiscountByID(id);
      getDiscountType();
    }
    else {
      navigate('/')
    }
  }, []);
  const getDiscountType = async () => {
    try {
      let type = await DiscountService.discountType().json();
      setDiscountType(type.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const getDiscountByID = async (id) => {
    try {
      let discount = await DiscountService.show(id).json();
      setDiscount(discount.data);
      // console.log(tutorial.data)
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "discount_type_id": event.target.discount_type_id.value,
        "coupon_code": event.target.coupon_code.value,
        "discount_amount": event.target.discount_amount.value,
        "start_date": event.target.start_date.value,
        "end_date": event.target.end_date.value,
      }
      var startDate = new Date(userData.start_date);
      var endDate = new Date(userData.end_date);

      // Validate if start date is later than end date
      if (startDate > endDate) {
        setError("The Start Date cannot be later than the End Date.");
        return; // Exit the function if the dates are not valid
      }
      else {
        let responseData = await DiscountService.update(params.id, userData).json()
        // console.log(responseData)
        if (responseData.status === true) {
          navigate("/admin/discount");
        }
      }

    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Discount" pageTitle={'Edit Discount'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Discount</h4>
                </div>
                <div className="card-body">

                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Discount type<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="discount_type_id">
                        {discountType.map((option) => {
                          return (
                            <option key={option.id} value={option.id} selected={discount.discount_type_id == option.id}>
                              {option.discount_type}
                            </option>
                          );
                        })}
                      </select>

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Coupon Code<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='coupon_code' id="val-username" placeholder="" defaultValue={
                        discount.coupon_code
                          ? discount.coupon_code
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Discount Amount / Percentage<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='discount_amount' id="val-username" placeholder="" defaultValue={
                        discount.discount_amount
                          ? discount.discount_amount
                          : ''
                      } />
                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Validity Time Frame </h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate</label>
                      <input type="date" className="form-control" name='start_date'
                        defaultValue={
                          discount.start_date
                            ? discount.start_date
                            : ''}
                        id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate</label>
                      <input type="date" className="form-control" name='end_date'
                        defaultValue={
                          discount.end_date
                            ? discount.end_date
                            : ''}
                        id="val-username"
                      />
                    </div>
                    <h5 style={{ color: 'red' }}>{error}</h5>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div>
            <button type="submit" className="btn btn-primary me-1">Submit</button>
          </div>
        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default EditDiscount;